module.exports = __webpack_public_path__ + "img/800x800.316fd796.svg";